import { Grid } from "@mui/material";
import MxFormL3AutoComplete from "@rf-l3/form/MxForml3AutoComplete";
import useModal from "@rf/base/modal/useModal";
import { CModalSchemaKeys } from "./BuildingUnitFormModal";
import MxFormSubTitle from "@rf-l1/page/form/MxFormSubTitle";

const FeaturesAndAmenities = () => {
  const { getData } = useModal();

  const { feature } = getData() as any;
  return (
    <Grid container spacing={1} rowGap={2}>
      <Grid container item xs={12}>
        <MxFormSubTitle label="Características y amenidades" />
      </Grid>
      <Grid item xs={6} lg={4}>
        <MxFormL3AutoComplete
          withreacthookform={1}
          name={CModalSchemaKeys.characteristics_frames_property}
          items={feature?.unit?.frames ?? []}
          label="Marcos"
        />
      </Grid>
      <Grid item xs={6} lg={4}>
        <MxFormL3AutoComplete
          withreacthookform={1}
          name={CModalSchemaKeys.characteristics_closets_property}
          items={feature?.unit?.closet ?? []}
          label="Closets"
        />
      </Grid>
      <Grid item xs={6} lg={4}>
        <MxFormL3AutoComplete
          withreacthookform={1}
          name={CModalSchemaKeys.characteristics_door_property}
          items={feature?.unit?.doors ?? []}
          label="Puerta"
        />
      </Grid>
      <Grid item xs={6} lg={4}>
        <MxFormL3AutoComplete
          withreacthookform={1}
          name={CModalSchemaKeys.characteristics_roof_property}
          items={feature?.unit?.roof ?? []}
          label="Tipo de techo"
        />
      </Grid>
      <Grid item xs={6} lg={4}>
        <MxFormL3AutoComplete
          withreacthookform={1}
          name={CModalSchemaKeys.characteristics_windows_property}
          items={feature?.unit?.windows ?? []}
          label="Ventana"
        />
      </Grid>
      <Grid item xs={6} lg={4}>
        <MxFormL3AutoComplete
          withreacthookform={1}
          name={CModalSchemaKeys.characteristics_cabinets_property}
          items={feature?.unit?.cabinets ?? []}
          label="Gabinetes"
        />
      </Grid>
      <Grid item xs={6} lg={4}>
        <MxFormL3AutoComplete
          withreacthookform={1}
          name={CModalSchemaKeys.characteristics_floors_property}
          items={feature?.unit?.floors ?? []}
          label="Pisos"
        />
      </Grid>
      <Grid item xs={6} lg={4}>
        <MxFormL3AutoComplete
          withreacthookform={1}
          name={CModalSchemaKeys.characteristics_type_house_property}
          items={feature?.unit?.houseType ?? []}
          label="Tipo de casa"
        />
      </Grid>
      <Grid item xs={6} lg={4}>
        <MxFormL3AutoComplete
          withreacthookform={1}
          name={CModalSchemaKeys.characteristics_roof_form_property}
          items={feature?.unit?.roofForm ?? []}
          label="Forma de techo"
        />
      </Grid>
      <Grid item xs={6} lg={8}>
        <MxFormL3AutoComplete
          isMultiple={true}
          withreacthookform={1}
          name={CModalSchemaKeys.features}
          items={feature?.unit?.improvements ?? []}
          label="Mejoras"
        />
      </Grid>
    </Grid>
  );
};

export default FeaturesAndAmenities;
